import { useEffect, useRef } from "react";

export default function useActivePage<T>(items: T[], itemId: number, item: T, search: any, owner: any, sortBy: any, setPage: (page: number) => void, pageSize: number = 10) {
    const lastActionRef = useRef(Action.Item);

    const setFirstPage = () => {
        setPage(1);
    }

    const setItemPage = () => {
        const index = items.indexOf(item);
        if (index === -1)
            return;

        setPage(getPageOfElementWithIndex(index, pageSize));
    }

    useEffect(() => {
        setFirstPage();
        lastActionRef.current = Action.Filter;
    }, [search, owner, sortBy]);

    useEffect(() => {
        setItemPage();
        lastActionRef.current = Action.Item;
    }, [itemId]);

    useEffect(() => {
        if (lastActionRef.current === Action.Item)
            setItemPage();
        else
            setFirstPage();
    }, [items]);
}

const getPageOfElementWithIndex = (index: number, pageSize: number) => Math.floor(index / pageSize + 1);

enum Action {
    Filter,
    Item,
}